export default "skymp5-front/54a766a458683d83e3f3471e0c6336eb.gif";